import { componentStyle } from '@/styling/util/component-style.ts';
import type { MessageDesignTokens } from '@primeuix/themes/types/message';

export const messageStyle = componentStyle<MessageDesignTokens>({
    info: {
        background: '{color.messageInfoBackground}',
        borderColor: '{color.messageInfoBackground}',
        color: '{primary.500}',
    },
    warn: {
        background: '{color.messageWarnBackground}',
        borderColor: '{color.messageWarnBorderColor}',
        color: '{color.messageWarnTextColor}',
    },
});
